import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.commissions')
  .factory('$consolidatedCommission', ConsolidatedCommissionObjectFactory);

/* @ngInject */
function ConsolidatedCommissionObjectFactory($bringozFactory: $bringozFactory,
                                             ConsolidateCommissionsApi: BringozApi,
                                             Consolidated_Commission_DS: DataStoreConfig,
                                             ConsolidatedCommissions_PN: PushNotificationsConfig) {
  function $consolidatedCommission(id: string) {
    return $bringozFactory(id, ConsolidateCommissionsApi, Consolidated_Commission_DS, ConsolidatedCommissions_PN)
  }

  return $consolidatedCommission;
}

